export const DAY = 'timeGridDay';

export const WORKWEEK = 'timeGridWorkweek';

export const WEEK = 'timeGridWeek';

export const DAY_PLUS_SEVEN = 'timeGridDayPlusSeven';

export const MONTH = 'dayGridMonth';
